import React, { useMemo } from "react"
import { Box, Grid } from "@material-ui/core";
import { PaymentRow, usePaymentsLoader } from "./usePaymentsLoader";
import MaterialTable, { Column } from "material-table";
import {
  getYesterdayDateTime,
  RangeFilterComponent
} from "../../../../../components/table/filters/RangeFilterComponent"
import { useAllAssets } from "../../../../../hooks/useAllAssets";
import {
  DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS,
  PaginationProps,
  SimpleTablePagination,
} from "../../../../../components/table/pagination/SimpleTablePagination"
import { tableIcons } from "../../../../../components/utils/material-table";
import {AssetViewCell, makeFilterSelector} from "./AssetFilterSelector";
import {useProfile} from "../../../../../hooks/useProfile";
import {SelectFilterComponent} from "../../../../../components/table/filters/SelectFilterComponent";
import {ClientCell} from "../components/client/ClientCell";

export const PaymentsTable = () => {
  const {client, profile} = useProfile()

  var portfolioId
  if (profile?.role === 'admin') {
    portfolioId = 0
  } else {
    portfolioId = client?.clientPortfolioId
  }
  const { loader, isLastPage } = usePaymentsLoader(portfolioId, getYesterdayDateTime()),
    { assets } = useAllAssets(false, false);

  const tableHeaders = useMemo((): Column<PaymentRow>[] => {
    const headers: Column<PaymentRow>[] = [
      {
        title: "Date",
        field: "date",
        filterComponent: RangeFilterComponent,
      },
      {
        title: "Time",
        field: "time",
        filtering: false,
      },
      {
        title: "Type",
        field: "type",
        filtering: false,
      },
      {
        title: "Asset",
        field: "asset",
        filterComponent: makeFilterSelector(assets),
        render: AssetViewCell(assets)
      },
      {
        title: "Quantity",
        field: "quantity",
        type: "numeric",
        filtering: false,
      },
    ]
    if (profile?.role === 'admin') {
      return [
        ...headers,
        {
          title: "Client",
          field: "clientId",
          filterComponent: SelectFilterComponent,
          render: ClientCell
        },
      ]
    } else {
      return headers;
    }
  }, [assets, profile]);

  return (
    <>
      <Box mt={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MaterialTable<PaymentRow>
              title="Payments"
              components={{
                Pagination: (p: PaginationProps) => (
                  <SimpleTablePagination isLastPage={isLastPage} {...p} />
                ),
              }}
              icons={tableIcons}
              columns={tableHeaders}
              options={{
                search: false,
                filtering: true,
                exportButton: true,
                pageSize: DEFAULT_PAGE_SIZE,
                pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
                toolbar: true,
                paging: true,
                sorting: true
              }}
              data={loader}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
